'use strict';
const mmWidgets = require('../widgets/mm-widgets');
mmWidgets.fn.themeStyleColorPicker = function (mapThemeModel, colorPickerModel) {
	return mmWidgets.each(this, function () {
		const widget = this,
			themeColorAttrPath = widget.attr('data-mm-theme-color').split('.'),
			themeImageAttr = widget.attr('data-mm-theme-image'),
			themeImageAttrPath = themeImageAttr && themeImageAttr.split('.'),
			selectImageOrColor = async () => {
				const result = await colorPickerModel.pickColorOrImage();
				if (result?.image) {
					mapThemeModel.overrideThemeAttribute(themeColorAttrPath, undefined);
					mapThemeModel.overrideThemeAttribute(themeImageAttrPath, result.image);
				} else {
					mapThemeModel.overrideThemeAttribute(themeColorAttrPath, result?.color || undefined);
					mapThemeModel.overrideThemeAttribute(themeImageAttrPath, undefined);
				}
			},
			selectColor = async () => {
				const result = await colorPickerModel.pickColor();
				mapThemeModel.overrideThemeAttribute(themeColorAttrPath, result || undefined);
			};
		mapThemeModel.addEventListener('themeJSONChanged', () => {
			const color = mapThemeModel.getThemeAttribute(themeColorAttrPath);
			widget.domElements[0].style.backgroundColor = color;
		});
		widget.click(async () => {
			try {
				if (themeImageAttr) {
					await selectImageOrColor();
				} else {
					await selectColor();
				}
			} catch (e) {
				console.error(e);
			}
			widget.trigger('click-complete');
		});
	});
};

